import React, { type FunctionComponent, Fragment } from 'react'
import { Flipper } from 'legacy/contexts/flipper/FlipperContext'
import { useHasAccess } from 'legacy/components/AccessControl/useHasAccess'

export const RetailerFilesSection: FunctionComponent = () => {
  const canAccess = useHasAccess({ flippers: [Flipper.ModernFilesSection] })

  if (!canAccess) {
    return null
  }

  return <Fragment>Coming Soon</Fragment>
}
